// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-container-SfBIB {
  flex: 0 0 auto;
  cursor: default;
  padding: 8px 20px 0px;
  border-radius: var(--small-border-radius);
}

.tab-container-SfBIB:hover {
  background-color: var(--background-color);
}

.tab-title-ZEaF7 {
  font-size: 16px;
  font-weight: 500;
}

.tab-disabledTitle-F_wDG {
  color: gray;
}

.tab-indicator-Pvhd7 {
  height: 4px;
  margin-top: 8px;
  border-radius: 1px;
}

.tab-indicatorOn-Gu5eL {
  background-color: var(--accent-color);
}

@media (min-width: 768px) {

  .tab-tab-By38p {
    margin: 0px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/tab/tab.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".container {\n  flex: 0 0 auto;\n  cursor: default;\n  padding: 8px 20px 0px;\n  border-radius: var(--small-border-radius);\n}\n\n.container:hover {\n  background-color: var(--background-color);\n}\n\n.title {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.disabledTitle {\n  color: gray;\n}\n\n.indicator {\n  height: 4px;\n  margin-top: 8px;\n  border-radius: 1px;\n}\n\n.indicatorOn {\n  background-color: var(--accent-color);\n}\n\n@media (min-width: 768px) {\n\n  .tab {\n    margin: 0px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `tab-container-SfBIB`,
	"title": `tab-title-ZEaF7`,
	"disabledTitle": `tab-disabledTitle-F_wDG`,
	"indicator": `tab-indicator-Pvhd7`,
	"indicatorOn": `tab-indicatorOn-Gu5eL`,
	"tab": `tab-tab-By38p`
};
export default ___CSS_LOADER_EXPORT___;
